<div [ngSwitch]="loaderType">
  <div *ngSwitchCase="'spinner'">
    <i
      class="fa fa-spin"
      [class]="spinnerType"
      [style.font-size]="loaderSize"
      [style.color]="loaderColor"
    ></i>
  </div>
  <div *ngSwitchCase="'full-screen'">
    <div class="loader-overlay" *ngIf="isVisible">
      <div class="loader-background"></div>
      <div class="loader">
        <div class="spinner"></div>
      </div>
    </div>
  </div>
  <div class="progress-bar-wave" *ngSwitchCase="'progress-bar-wave'">
    <div class="loader" *ngIf="isVisible"></div>
  </div>
  <div *ngSwitchDefault>
    <!-- Default content goes here -->
    <p>No loader</p>
  </div>
</div>
